<template>
  <PageHeader
    title="Telephony"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  />

  <div class="p-4">
    <div class="bg-white rounded-lg border border-gray-200">
      <div class="border-b border-gray-200">
        <nav class="flex -mb-px px-4" aria-label="Tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            class="whitespace-nowrap py-3 px-4 border-b-2 text-sm font-medium"
            :class="activeTab === tab.id
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
            @click="switchTab(tab.id)"
          >{{ tab.label }}</button>
        </nav>
      </div>

      <TelephonyCallLogs_Admin v-if="activeTab === 'call_logs'" />
      <TelephonyPhoneNumbers_Admin v-if="activeTab === 'phone_numbers' && showPhoneNumbers" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import TelephonyCallLogs_Admin from './TelephonyCallLogs_Admin.vue'
import TelephonyPhoneNumbers_Admin from './TelephonyPhoneNumbers_Admin.vue'

const TAB_ROUTE_MAP = {
  call_logs: 'AdminTelephonyCallLogs',
  phone_numbers: 'AdminTelephonyPhoneNumbers',
}

export default {
  name: 'Telephony_Admin',

  components: {
    PageHeader,
    TelephonyCallLogs_Admin,
    TelephonyPhoneNumbers_Admin,
  },

  computed: {
    ...mapGetters('auth', ['current_user']),

    showPhoneNumbers() {
      return import.meta.env.VITE_ENV === 'sandbox' || this.current_user?.is_superuser
    },

    tabs() {
      const allTabs = [
        { id: 'call_logs', label: 'Call Logs' },
        { id: 'phone_numbers', label: 'Phone Numbers' },
      ]
      if (!this.showPhoneNumbers) {
        return allTabs.filter(t => t.id !== 'phone_numbers')
      }
      return allTabs
    },

    activeTab() {
      return this.$route.meta.telephonyTab || 'call_logs'
    },
  },

  methods: {
    switchTab(tabId) {
      const routeName = TAB_ROUTE_MAP[tabId]
      if (routeName && this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },
  },
}
</script>
